export default __webpack_public_path__ + "static/media/location_pin_outlined.b77d206b.svg";